import React from 'react'
import Modal from 'react-bootstrap/Modal';
import Fade from 'react-bootstrap/Fade';
import {KTIcon} from '../../../_metronic/helpers'
import {DemandeDemontageValidationForm} from './components/DemandeDemontageValidationForm'

const DemandeDemontageValidationModal = ({show, demandeDemontageId, showModal, data, setData}) => {

  return (
    <>
      <Modal
        size='lg'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        show={show}
        onHide={() => showModal(false)}
        backdrop={true}
        transition={Fade}
        backdropTransition={Fade}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              Validation de la demande de démontage pour la demande n° : {demandeDemontageId}
            </h5>
            <div
              className='btn btn-icon btn-sm btn-light-primary ms-2'
              onClick={() => showModal(false)}
            >
              <KTIcon className='fs-2' iconName='cross' />
            </div>
          </div>
          <DemandeDemontageValidationForm
            demandeDemontageId={demandeDemontageId}
            showModalProp={showModal}
            data={data}
            setData={setData}
          />
        </div>
      </Modal>
    </>
  )
}

export {DemandeDemontageValidationModal}
